<template>
  <VDataGridV2
    entity-type="transportRoute"
    :loader="loader"
    :context-menu="TransportRoutesService.contextMenu"
    paginated
    @row:dblclick="openCard"
  >
    <VDataGridColumnV2
      id="id"
      width="50px"
      content-align="left"
      label="№"
    >
      <template #default="{ row }">
        <VLink @click="openCard(row)">{{ row.id }}</VLink>
        <VBadge v-if="row.isDeleted" class="warning">Удалён</VBadge>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="zoneFrom"
      width="250px"
      content-align="left"
      label="Откуда"
    >
      <template #default="{ row }">
        {{ row.zoneFrom?.name }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="zoneTo"
      width="250px"
      content-align="left"
      label="Куда"
    >
      <template #default="{ row }">
        {{ row.zoneTo?.name }}
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="costPerKg"
      width="120px"
      content-align="right"
      label="Цена за кг"
    >
      <template #default="{ row }">
        <span class="nowrap">{{ row.costPerKg?.format(row.costCurrencyCode) }}</span>
      </template>
    </VDataGridColumnV2>

    <VDataGridColumnV2
      id="costPerM3"
      width="120px"
      content-align="right"
      label="Цена за м³"
    >
      <template #default="{ row }">
        <span class="nowrap">{{ row.costPerM3?.format(row.costCurrencyCode) }}</span>
      </template>
    </VDataGridColumnV2>

    <VDataGridActionBarV2>
      <VButton
        theme="primary"
        @click="openCard()"
      >
        Создать новый маршрут
      </VButton>
    </VDataGridActionBarV2>
  </VDataGridV2>
</template>

<script lang="ts">

import DataGridLoader            from '@/lib/components/VDataGridV2/DataGridLoader';
import TransportRoute            from '@/domains/TransportRoutes/TransportRoute';
import TransportRoutesService    from '@/domains/TransportRoutes/TransportRoutesService';

export default defineComponent({
  name: 'TransportRoutesRegistry',

  setup() {
    return {
      TransportRoutesService,
    }
  },

  data() {
    return {
      loader: new DataGridLoader(TransportRoutesService.getListPaginated),
    };
  },

  methods: {
    async openCard(route?: TransportRoute): Promise<void> {
      if (await TransportRoutesService.showCard(route ?? null)) {
        await this.loader.refresh();
      }
    },
  },
});
</script>
